export default __webpack_public_path__ + "static/char-53-40ad215515d38cf270faf51f1c3dd2bc.webp";